(() => {
  'use strict';
  const selector = '[data-xifun-feature-banner]';
  const controllers = new Map();
  const init = (scope = document) => {
    const sections = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    sections.forEach((section) => {
      if (controllers.has(section)) return;
      const item = section.querySelector('[data-xifun-reveal]');
      if (!item || section.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) { item?.classList.add('is-visible'); controllers.set(section, null); return; }
      section.classList.add('is-enhanced');
      const observer = new IntersectionObserver(([entry]) => { if (entry?.isIntersecting) { item.classList.add('is-visible'); observer.disconnect(); } }, { rootMargin: '100px 0px', threshold: .12 });
      observer.observe(item);
      const fallback = window.setTimeout(() => item.classList.add('is-visible'), 700);
      controllers.set(section, { disconnect: () => { window.clearTimeout(fallback); observer.disconnect(); } });
    });
  };
  const destroy = (section) => { controllers.get(section)?.disconnect(); controllers.delete(section); };
  if (!window.__xifunFeatureBannerLoaded) { window.__xifunFeatureBannerLoaded = true; document.addEventListener('shopify:section:load', (event) => init(event.target)); document.addEventListener('shopify:section:unload', (event) => destroy(event.target)); window.addEventListener('pageshow', () => init()); }
  init();
})();
